import ApiClient from './ApiClient';

class FollowUpsAPI extends ApiClient {
  constructor() {
    super('follow_up_rules', { accountScoped: true });
  }

  getRules() {
    return axios.get(this.url);
  }

  toggleActive(id) {
    return axios.post(`${this.url}/${id}/toggle_active`);
  }

  simulateAi(data) {
    return axios.post(`${this.url}/simulate_ai`, data);
  }

  runEngineNow() {
    return axios.post(`${this.url}/run_engine_now`);
  }

  getExecutionsHistory(params = {}) {
    return axios.get(`${this.url}/executions_history`, { params });
  }
}

export default new FollowUpsAPI();
